// src/hooks/useHomeDataLoader.js
import { useEffect, useContext } from 'react';
import axios from 'axios';
import { HomeContext } from '../Context/HomeContext';

export const useHomeDataLoader = () => {
  const { homeData, setHomeData, setLoading, setError } = useContext(HomeContext);

  useEffect(() => {
    const fetchHomeData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/home', {
          headers: {
            Accept: 'application/json',
            'Client-Domain':'www.clevercoverageofficial.com',
          },
        });

        setHomeData(res.data);
      } catch (err) {
        console.error("Error fetching home data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (!homeData) {
      fetchHomeData();
    }
  }, [homeData, setHomeData, setLoading, setError]);
};
